import { render, staticRenderFns } from "./NeueVueApp.vue?vue&type=template&id=871e4a60&scoped=true&"
import script from "./NeueVueApp.vue?vue&type=script&lang=js&"
export * from "./NeueVueApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "871e4a60",
  null
  
)

export default component.exports